'use client'

import { createContext, useContext } from 'react'

import { EmbroiderableProductFlatlayImage } from '../../../../types/graphql/product'

const PreviewFlatlayImageContext = createContext<EmbroiderableProductFlatlayImage | undefined>(
  undefined
)

// Provides the active slide's flatlay image to preview items so they can
// position themselves using the current slide's placement offsets
export const PreviewFlatlayImageProvider = ({
  children,
  flatlayImage,
}: {
  children?: React.ReactNode
  flatlayImage?: EmbroiderableProductFlatlayImage
}) => {
  return (
    <PreviewFlatlayImageContext.Provider value={flatlayImage}>
      {children}
    </PreviewFlatlayImageContext.Provider>
  )
}

export const usePreviewFlatlayImage = () => {
  return useContext(PreviewFlatlayImageContext)
}
